/**
 * The one keyboard focus indicator for the redesign: a solid 2px accent ring
 * with a 2px bg-coloured gap. Solid accent on bg/surface is ≥3:1 (WCAG 2.2
 * 1.4.11 / 2.4.13); the previous 25–30% accent tint was not.
 *
 * Use `focusRing` on focusable elements, `focusWithinRing` on a wrapper whose
 * hidden input takes focus (radio cards).
 */
export const focusRing =
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-sl-accent focus-visible:ring-offset-2 focus-visible:ring-offset-sl-bg';

export const focusWithinRing =
  'has-[:focus-visible]:ring-2 has-[:focus-visible]:ring-sl-accent has-[:focus-visible]:ring-offset-2 has-[:focus-visible]:ring-offset-sl-bg';
